export default __webpack_public_path__ + "static/media/replaceIcon.6a0edbdc.svg";